import React from 'react';

const Lessons = () => {
  return <div>Lessons (Private)</div>;
};

Lessons.propTypes = {};

export default Lessons;
